import * as React from 'react';

import { StyleSheet, css, fontFamily } from '@coursera/coursera-ui';

const styles = StyleSheet.create({
  common: {
    color: 'var(--cds-color-blue-950)',
  },

  cardTitle: {
    fontWeight: 'normal',
    fontFamily: fontFamily.body,
    fontSize: '1.5rem',
    lineHeight: '1.875rem',
    margin: 0,
  },

  tabCaption: {
    fontWeight: 'bold',
    fontFamily: fontFamily.bold,
    fontSize: '1rem',
    lineHeight: '1.875rem',
  },
});

/*
 * hierarchy assumptions:
 * - page has h1
 * - card title is h2
 * - card subheadings are h3
 */

export const CardTitle: React.LegacyFunctionComponentWithChildren = (props) => (
  <h2 {...css(styles.common, styles.cardTitle)}>{props.children}</h2>
);

export const TabCaption: React.LegacyFunctionComponentWithChildren = (props) => (
  <h3 {...css(styles.common, styles.tabCaption)}>{props.children}</h3>
);
